import React from 'react';
import LoginPageHeader from './LoginPageHeader';
import LoginPageLayout from './LoginPageLayout';
import ContentBlock from './ContentBlock';
import StepperBlock from './StepperBlock';

const LoginPageShell = ({ children, isWelcomeStep, onLanguageChange, showStepper = false, currentStep = 1 }) => (
  <>
    <LoginPageHeader isWelcomeStep={isWelcomeStep} onLanguageChange={onLanguageChange} />
    <LoginPageLayout showStepper={showStepper}>
      {showStepper && <StepperBlock currentStep={currentStep} />}
      <ContentBlock hasStepper={showStepper}>
        {children}
      </ContentBlock>
    </LoginPageLayout>
  </>
);

export default LoginPageShell;
